import groupingsMixin from '@/mixins/groupings';
import { stripHtml } from '@/utils';

export default {
  mixins: [groupingsMixin],
  data () {
    return {
      activeTabId: null,
    };
  },
  props: {
    flashcard: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    assetTrayGrouping () {
      return this.getAssetTrayGrouping(this.flashcard);
    },
    assetTrayTabs () {
      const assetAssociations = this.assetTrayGrouping?.assetAssociations || [];
      const rootTopics = assetAssociations
        .map(aa => aa.assetBContext)
        .map(id => this.$store.getters['topics/topics'][id] || {});

      const tabGroupings = assetAssociations
        .map(aa => +aa.assetBId)
        .filter(id => id > 0)
        .map(id => this.$store.getters['groupings/all'][id]);

      const topicSets = tabGroupings.map(g => this.getTopics(g).filter(t => t?.content)).filter(ts => ts && ts.length);

      if (topicSets.length > 0) {
        this.activeTabId = rootTopics[0].id;
      }
      const tabs = topicSets
        .map((topicSet, index) => {
          const subTopics = topicSet
            .map(topic => ({
              id: topic.id,
              title: stripHtml(topic.title),
              content: topic.content,
            }));
          return {
            id: rootTopics[index].id,
            buttonTitle: stripHtml(rootTopics[index].title),
            subTopics,
            newContent: assetAssociations[index].displayType === 'new_content',
            order: assetAssociations[index].order,
          };
        })
        .sort((a, b) => a.order - b.order);

      if (tabs.length > 0) {
        this.activeTabId = tabs[0].id;
      }
      return tabs;
    },
    showAssetTray () {
      return this.$store.getters['ui/showAssetTray'];
    },
    firstTabId () {
      return this.assetTrayTabs[0]?.id || null;
    },
  },
  watch: {
    flashcard () {
      this.activeTabId = this.firstTabId;
    },
  },
  mounted () {
    this.activeTabId = this.firstTabId;
  },
  methods: {
    getTopics (grouping) {
      const assetAssociations = (grouping?.assetAssociations || []).sort((a, b) => a.order - b.order);
      const topicIds = assetAssociations
        .map(aa => +aa.assetBId)
        .filter(id => id > 0);
      return topicIds.map(id => this.$store.getters['topics/topics'][id]);
    },
    toggleAssetTray () {
      this.$store.commit('ui/setShowAssetTray', !this.showAssetTray);
      if (this.showAssetTray) {
        this.$nextTick(() => {
          const el = document.getElementById('asset-tray');
          if (el) {
            el.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        });
      }
    },
  },
};
